var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/contactus/solid/icon-whatsapp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.7296454,3 C22.3986848,3 27.8211986,8.2852349 27.9881364,14.8678395 C27.9940682,14.9720697 28,15.0746051 28,15.1788353 C28,21.9046505 22.5020677,27.3568233 15.7296454,27.3568233 C13.5764016,27.3568233 11.55281,26.8051658 9.79614941,25.8391296 L3,28 L5.21764626,21.4623076 C4.09738323,19.6302285 3.45335909,17.4752898 3.45335909,15.1788353 C3.45335909,15.0000339 3.4601383,14.8220799 3.4720019,14.6441258 C3.75249136,8.16405667 9.13009288,3 15.7296454,3 Z M15.7296454,4.9430886 C10.3757711,4.9430886 5.96505322,9.00383025 5.46000271,14.1848349 C5.43119111,14.5119314 5.4133957,14.8449597 5.4133957,15.1788353 C5.4133957,17.418514 6.14300725,19.4921022 7.37173751,21.1809708 L6.08453664,24.978171 L10.0486747,23.7197817 C11.67992,24.7934377 13.6272456,25.4145821 15.724561,25.4145821 C21.416548,25.4145821 26.0450478,20.8242153 26.0450478,15.1788353 C26.0450478,14.9085147 26.0280998,14.638194 26.0119992,14.379737 C25.5984679,9.10636567 21.14538,4.9430886 15.7296454,4.9430886 Z M11.8205802,9 C12.0176919,9 12.2148036,9.02803252 12.3902912,9.02803252 C12.5591253,9.02803252 12.8069704,8.92826972 13.0556472,9.50870782 C13.2976704,10.0899704 13.8890055,11.5204535 13.9630263,11.665563 C14.0362155,11.8106725 14.0869489,11.9788677 13.9854821,12.1750953 C13.9181148,12.3094865 13.8715399,12.4150207 13.7991824,12.5213794 C13.7659146,12.5650772 13.737637,12.6104239 13.6918938,12.6607175 C13.5455155,12.8289127 13.3825033,13.0358586 13.246937,13.1694253 C13.1005587,13.3145349 12.9483585,13.4711872 13.1171926,13.7614062 C13.2918485,14.0524498 13.8840153,15.003082 14.7639485,15.7690295 C15.8908952,16.7584126 16.8381957,17.0651214 17.1376059,17.2102309 C17.4295308,17.3553404 17.6041867,17.3330793 17.7738525,17.1376761 C17.9485084,16.9472199 18.5123976,16.2934025 18.7095093,16.0031835 C18.906621,15.7121399 19.1045644,15.7566622 19.3748652,15.858074 C19.4907084,15.8987093 19.8231658,16.050196 20.1887939,16.2219319 L20.5586847,16.3970618 C20.9260442,16.5722302 21.2654266,16.7374471 21.3933888,16.8021103 C21.6861454,16.9472199 21.8832571,17.0205991 21.957278,17.1376761 C22.0304671,17.2605245 22.0304671,17.8417871 21.7884439,18.5186901 C21.5405988,19.1997154 20.3338095,19.8535328 19.7923761,19.8988795 C19.7127535,19.9062756 19.6448402,19.920911 19.5773759,19.9368018 L19.4959138,19.9560904 C19.1238185,20.0421546 18.6334826,20.0950344 16.2518508,19.1725074 C13.246937,18.0091577 11.3531676,14.9799964 11.2059576,14.7903647 C11.0936788,14.6452552 10.4507787,13.8009816 10.1513685,12.7720231 C10.0615454,12.459543 10,12.1239772 10,11.7892359 C10,10.3579283 10.7668227,9.65381734 11.0371236,9.36277381 C11.3074244,9.07255476 11.6234685,9 11.8205802,9 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.0%",
    y: "-8.0%",
    width: "132.0%",
    height: "132.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/contactus/solid/icon-whatsapp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.06570877e25533a85c2537b59c19e533.svg";
export { ForwardRef as ReactComponent };